<template>
  <div class="admin-page">
    <div class="admin-page-inner">
      <div class="admin-page-header">
        <div>
          <h1 class="admin-page-title">Auswertungen</h1>
        </div>
      </div>
      <div class="px-4">
        <div class="admin-tabs">
          <button
            v-for="tab in tabs"
            :key="tab.id"
            type="button"
            @click="switchTab(tab)"
            :class="['admin-tab', activeTab.id === tab.id ? 'admin-tab--active' : '']"
          >
            {{ tab.name }}
          </button>
        </div>

        <div v-if="loading" class="text-center py-10">
          <i class="fas fa-spinner fa-spin fa-3x"></i>
          <p class="mt-4">Dashboard wird geladen...</p>
        </div>
        <div v-else-if="error" class="text-center py-10 text-red-500">
          <i class="fas fa-exclamation-triangle fa-3x"></i>
          <p class="mt-4">{{ error }}</p>
        </div>
        <div v-else-if="dashboardToken" class="w-full" style="height: calc(100vh - 320px);">
          <metabase-dashboard 
            v-if="activeTab.type === 'dashboard'"
            :token="dashboardToken" 
            with-title="false" 
            with-downloads="false"
            with-navigation="true"
            class="rounded-lg shadow-lg"
            style="width: 100%; height: 100%;"
          ></metabase-dashboard>
          <metabase-question
            v-else-if="activeTab.type === 'question'"
            :token="dashboardToken" 
            with-title="false" 
            with-downloads="false"
            class="rounded-lg shadow-lg"
            style="width: 100%; height: 100%;"
          ></metabase-question>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CASP from "../../CASP";

export default {
  data() {
    return {
      dashboardToken: null,
      loading: true,
      error: null,
      stats: { permissions: {} },
      tabs: [
        { id: 'dashboard', name: 'Dashboard', type: 'dashboard', resourceId: 2 },
        { id: 'mitarbeiter_jobs', name: 'Mitarbeiterjobs', type: 'question', resourceId: 40 },
        { id: 'mitarbeiter_stunden', name: 'Mitarbeiterstunden', type: 'question', resourceId: 41 },
        { id: 'umsaetze_loehne_gewinne', name: 'Umsätze/Löhne/Gewinne', type: 'question', resourceId: 45 },
        { id: 'monatsstunden_soll_ist', name: 'Monatsstunden Soll/Ist', type: 'question', resourceId: 46 }
      ],
      activeTab: null
    };
  },
  methods: {
    switchTab(tab) {
      this.loading = true;
      this.dashboardToken = null;
      this.error = null;
      this.activeTab = tab;
      this.loadDashboard(tab.type, tab.resourceId);
    },
    async loadDashboard(type, id) {
      this.loading = true;
      this.error = null;
      this.dashboardToken = null;
      
      CASP.getMetabaseDashboardUrl(type, id, (status, response) => {
        this.loading = false;
        
        if (status === 200 && response.token) {
          this.dashboardToken = response.token;
        } else if (status === 401) {
          window.location = "/forbidden";
        } else if (status === 403) {
          this.error = "Sie haben keine Berechtigung, diese Auswertungen anzuzeigen.";
        } else {
          this.error = "Dashboard konnte nicht geladen werden. Bitte versuchen Sie es später erneut.";
        }
      });
    }
  },
  created: function () {
    document.getElementById("mainspinner").style.display = "none";
    if (localStorage) localStorage.setItem("last", "/admin/auswertungen");
    
    this.activeTab = this.tabs[0];
    
    CASP.getStats((status, response) => {
      if (status == 401) {
        window.location = "/forbidden";
      } else if (status == 200) {
        this.stats = response;
        if (this.stats.permissions.admin) {
          this.loadDashboard(this.activeTab.type, this.activeTab.resourceId);
        } else {
          this.loading = false;
          this.error = "Sie haben keine Berechtigung, diese Auswertungen anzuzeigen.";
        }
      }
    });
  }
};
</script>
